<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT"><b>Acknowledgments</b></div>
<div class="fmtx1">This book is the result of many people’s generous efforts and much grace. Accordingly, we thank Joe O’Donnell, Penny Armstrong, and Brownie Anderson for their wise assistance; Tom Mellers for permissions help; and Samita Sinha and Diane Wachtell at The New Press for their direction, help, advice, and humor.</div>
<div> <br/></div><div class="fmtx1d">—ROBERT COLES AND RANDY TESTA</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// robe_9781595587800_oeb_ack_r1.vue?4532b85c